import { CloseButtonVariantType, } from '../../../../../../components/closeButton/types/closeButton';
import { CloseButtonStateType } from '../../../../../../components/closeButton/types/state';
import { containerPrimaryVariantsCommonStyles } from '../commonStyles';
export const getCustomStyles = (FOUNDATIONS, FONT) => {
    return {
        [CloseButtonVariantType.CUSTOM]: {
            [CloseButtonStateType.DEFAULT]: {
                container: {
                    ...containerPrimaryVariantsCommonStyles(FOUNDATIONS, FONT),
                },
                iconColor: FOUNDATIONS.color_comp_actions_closebuttontechonly_custom_default_icon,
            },
            [CloseButtonStateType.DISABLED]: {
                container: {
                    ...containerPrimaryVariantsCommonStyles(FOUNDATIONS, FONT),
                },
                iconColor: FOUNDATIONS.color_accent_disabled_icon_100,
            },
        },
    };
};
//# sourceMappingURL=custom.js.map